<section class="video-carousel">
  <ngu-carousel #myCarousel [inputs]="carouselTile" [dataSource]="videoArray">
    <!--LEFT ARROW START-->
    <i
      NguCarouselPrev
      class="leftRs icon white small arrow-left left-arrow cursor"
      [style.opacity]="myCarousel.isFirst ? 0.5 : 1"></i>
    <!--END LEFT ARROW-->

    <!--RIGHT ARROW START-->
    <i
      NguCarouselNext
      class="rightRs icon white small arrow-right right-arrow cursor"
      [style.opacity]="myCarousel.isLast ? 0.5 : 1"></i>
    <!--END RIGHT ARROW -->

    <!--CAROUSEL CONTENT START-->
    <ngu-tile class="embed-container" *nguCarouselDef="let video; index as i">
      <app-video-container
        [title]="video.title"
        [embedUrl]="video.embed_url"
        (sendClick)="sendGoogleAnalytics('videos', 'click', video.slug)">
      </app-video-container>
      <div class="cx-training-videos-title">
        <h3>
          <a
            class="gen-neutral-black-link"
            href="javascript:void(0);"
            [routerLink]="['/video', video?.slug]"
            routerLinkActive="active"
            (click)="sendGoogleAnalytics('videos', 'click', video.slug)">
            {{ video?.title | decodeEntities }}
          </a>
        </h3>
      </div>
      <!--BUTTON TO SHOW EXTERNAL LINK -->
      <div class="start-course margin-top-small">
        <a
          *ngIf="video?.external_url"
          href="{{ video?.external_url }}"
          target="_blank"
          rel="noopener noreferrer nofollow"
          class="btn btn-primary">
          {{ video?.external_link_cta }}
        </a>
      </div>
      <!--END BUTTON TO SHOW EXTERNAL LINK -->
    </ngu-tile>
    <!--END CAROUSEL CONTENT-->
    <!--SLIDER DOTS START-->
    <ul class="myPoint cursor" NguCarouselPoint>
      <li
        *ngFor="let i of myCarousel.pointNumbers(); let j = index; trackBy: trackByVideoItemId"
        [ngClass]="i === myCarousel.activePoint ? carouselDotActiveCSS : ''"
        (click)="myCarousel.moveTo(i)"
        [style.background]="'url(' + videoArray[i] + ')'"></li>
    </ul>
    <!--END SLIDER DOTS-->
  </ngu-carousel>
</section>
